document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleria();
  initVariantes();
  initCountUp();
  initParallax();
  initTilt();
  initHeroCarrusel();
  initHeroFiguras();
  initHeroCoche();
  initGaraje();
  initPlano();
  initCircuito();
  initStickyCompra();
  initTemaOscuro();
  initOfertaBienvenida();
  initPopupNuevo();
  initVideosAutoplay();
  initAlertaMini();
  initContadorVisitas();
  initCarrito();
  initAvisoAirbag();
  initVideos();
  initDatosAnimados();
  initOfertaListados();
});

// Hero "figuras": carrusel en profundidad (centro/izquierda/derecha/fondo)
// con las 4 posiciones del volante activo cambiando de sitio, escala,
// desenfoque y opacidad a la vez. Con flechas para elegir a mano.
function initHeroFiguras() {
  var raiz = document.querySelector('[data-mt-hero-figuras]');
  if (!raiz) return;

  var items = Array.prototype.slice.call(raiz.querySelectorAll('[data-mt-figura]'));
  var total = items.length;
  if (total < 2) return;

  var activeIndex = 0;
  var isAnimating = false;

  function aplicarRoles() {
    var centro = activeIndex;
    var izquierda = (activeIndex + total - 1) % total;
    var derecha = (activeIndex + 1) % total;

    items.forEach(function (el, i) {
      el.classList.remove('mt-figura-centro', 'mt-figura-izq', 'mt-figura-der', 'mt-figura-fondo');
      if (i === centro) el.classList.add('mt-figura-centro');
      else if (i === derecha) el.classList.add('mt-figura-der');
      else if (i === izquierda) el.classList.add('mt-figura-izq');
      else el.classList.add('mt-figura-fondo');
    });

    var bg = items[centro].dataset.mtBg;
    if (bg) raiz.style.backgroundColor = bg;
    raiz.classList.toggle('mt-hero-carbono', items[centro].dataset.mtCarbono === 'true');
  }

  function navegar(direccion) {
    if (isAnimating) return;
    isAnimating = true;
    activeIndex = direccion === 'next' ? (activeIndex + 1) % total : (activeIndex + total - 1) % total;
    aplicarRoles();
    setTimeout(function () { isAnimating = false; }, 650);
  }

  var btnPrev = raiz.querySelector('[data-mt-figura-prev]');
  var btnNext = raiz.querySelector('[data-mt-figura-next]');
  if (btnPrev) btnPrev.addEventListener('click', function () { navegar('prev'); });
  if (btnNext) btnNext.addEventListener('click', function () { navegar('next'); });

  aplicarRoles();
}

// Portada · La gama: al elegir un chasis se resaltan los modelos que lo
// indican en su ficha y se atenúan los demás. "Todos" lo reinicia.
function initGaraje() {
  document.querySelectorAll('[data-mt-garaje]').forEach(function (raiz) {
    var chips = raiz.querySelectorAll('[data-mt-chip]');
    var tarjetas = raiz.querySelectorAll('[data-mt-chasis]');
    var resultado = raiz.querySelector('[data-mt-garaje-resultado]');
    if (!chips.length || !tarjetas.length) return;
    var plantillaSi = raiz.dataset.mtTextoResultado || '';
    var plantillaNo = raiz.dataset.mtTextoNinguno || '';

    function filtrar(chasis) {
      var cuantos = 0;
      chips.forEach(function (c) { c.classList.toggle('mt-activo', c.dataset.mtChip === chasis); });
      tarjetas.forEach(function (t) {
        var encaja = chasis && t.dataset.mtChasis.indexOf(',' + chasis + ',') !== -1;
        if (encaja) cuantos++;
        t.classList.toggle('mt-encaja', !!encaja);
        t.classList.toggle('mt-atenuado', !!chasis && !encaja);
        var etiqueta = t.querySelector('[data-mt-encaja-chasis]');
        if (etiqueta) etiqueta.textContent = chasis;
      });
      if (!resultado) return;
      if (!chasis) { resultado.textContent = ''; return; }
      var plantilla = cuantos === 1 ? (raiz.dataset.mtTextoUno || plantillaSi) : cuantos ? plantillaSi : plantillaNo;
      resultado.textContent = plantilla.replace('[n]', cuantos).replace('[chasis]', chasis);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { filtrar(chip.dataset.mtChip); });
    });
  });
}

// Portada · Plano técnico: el dibujo se "escanea" al aparecer en pantalla y
// cada punto del plano se enlaza con su línea de la leyenda (y al revés).
function initPlano() {
  document.querySelectorAll('[data-mt-plano]').forEach(function (raiz) {
    var dibujo = raiz.querySelector('[data-mt-plano-dibujo]');
    var puntos = raiz.querySelectorAll('[data-mt-punto]');
    var filas = raiz.querySelectorAll('[data-mt-punto-leyenda]');
    if (!dibujo) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      dibujo.classList.add('mt-visible');
    } else {
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { dibujo.classList.add('mt-visible'); obs.disconnect(); }
        });
      }, { threshold: 0.3 });
      obs.observe(dibujo);
    }

    function marcar(indice) {
      puntos.forEach(function (p) { p.classList.toggle('mt-activo', p.dataset.mtPunto === indice); });
      filas.forEach(function (f) { f.classList.toggle('mt-activo', f.dataset.mtPuntoLeyenda === indice); });
    }
    function limpiar() { marcar(null); }

    puntos.forEach(function (p) {
      p.addEventListener('mouseenter', function () { marcar(p.dataset.mtPunto); });
      p.addEventListener('focus', function () { marcar(p.dataset.mtPunto); });
      p.addEventListener('click', function () { marcar(p.dataset.mtPunto); });
      p.addEventListener('mouseleave', limpiar);
      p.addEventListener('blur', limpiar);
    });
    filas.forEach(function (f) {
      f.addEventListener('mouseenter', function () { marcar(f.dataset.mtPuntoLeyenda); });
      f.addEventListener('mouseleave', limpiar);
    });
  });
}

// Portada · Circuito: el coche avanza por la pista según lo que se ha bajado
// en la página, suelta humo mientras se mueve y va encendiendo cada paso.
function initCircuito() {
  document.querySelectorAll('[data-mt-circuito]').forEach(function (raiz) {
    var pista = raiz.querySelector('[data-mt-pista]');
    var coche = raiz.querySelector('[data-mt-pista-coche]');
    var hitos = raiz.querySelectorAll('[data-mt-hito]');
    var etapas = raiz.querySelectorAll('[data-mt-etapa]');
    if (!pista || !coche) return;

    var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ultimoX = -1;
    var paradaTimer = null;
    var pendiente = false;

    function actualizar() {
      pendiente = false;
      var vh = window.innerHeight;
      var r = pista.getBoundingClientRect();
      var inicio = vh * 0.85;
      var fin = vh * 0.3;
      var progreso = reducir ? 1 : (inicio - r.top) / (inicio - fin);
      progreso = Math.max(0, Math.min(1, progreso));

      var meta = 26;
      var recorrido = Math.max(0, r.width - coche.offsetWidth - meta - 6);
      var x = Math.round(progreso * recorrido);
      coche.style.transform = 'translateX(' + x + 'px)';

      var frente = x + coche.offsetWidth * 0.8;
      hitos.forEach(function (h, i) {
        var activo = frente >= h.offsetLeft + h.offsetWidth / 2;
        h.classList.toggle('mt-activo', activo);
        if (etapas[i]) etapas[i].classList.toggle('mt-activo', activo);
      });

      if (ultimoX !== -1 && x !== ultimoX && !reducir) {
        coche.classList.add('mt-en-marcha');
        clearTimeout(paradaTimer);
        paradaTimer = setTimeout(function () { coche.classList.remove('mt-en-marcha'); }, 220);
      }
      ultimoX = x;
    }

    function pedir() {
      if (!pendiente) { pendiente = true; window.requestAnimationFrame(actualizar); }
    }
    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir);
    actualizar();
  });
}

// Hero: coche en pixel art que cruza el banner de esquina a esquina cada
// X segundos (ajustable desde el editor), soltando humo por el tubo de
// escape. Se detiene solo si el visitante prefiere menos movimiento.
function initHeroCoche() {
  var coche = document.querySelector('[data-mt-figuras-coche]');
  if (!coche) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var intervalo = parseInt(coche.dataset.mtIntervalo, 10);
  if (!intervalo || intervalo < 5) intervalo = 30;

  function cruzar() {
    coche.classList.remove('mt-conduciendo');
    void coche.offsetWidth;
    coche.classList.add('mt-conduciendo');
  }

  coche.addEventListener('animationend', function () {
    coche.classList.remove('mt-conduciendo');
  });

  setTimeout(cruzar, 2500);
  setInterval(cruzar, intervalo * 1000);
}

// Hero: carrusel interactivo de volantes (cambia solo y se puede elegir a
// mano). Solo se activa si la sección tiene bloques "volante"; si no,
// mt-hero se comporta igual que siempre (una sola foto fija).
function initHeroCarrusel() {
  var raiz = document.querySelector('[data-mt-hero-carrusel]');
  if (!raiz) return;

  var slides = raiz.querySelectorAll('[data-mt-hero-slide]');
  var selectores = raiz.querySelectorAll('[data-mt-hero-selector]');
  var enlaceCompra = raiz.querySelector('[data-mt-hero-slide-link]');
  var nombreEl = raiz.querySelector('[data-mt-hero-slide-nombre]');
  var precioEl = raiz.querySelector('[data-mt-hero-slide-precio]');
  if (slides.length < 2 || !selectores.length) return;

  var actual = 0;
  var temporizador = null;
  var duracion = 4500;
  var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mostrar(indice) {
    actual = indice;
    slides.forEach(function (s, i) { s.classList.toggle('mt-activo', i === indice); });
    selectores.forEach(function (s, i) { s.classList.toggle('mt-activo', i === indice); });
    var boton = selectores[indice];
    if (!boton) return;
    if (enlaceCompra && boton.dataset.mtUrl) enlaceCompra.setAttribute('href', boton.dataset.mtUrl);
    if (nombreEl && boton.dataset.mtNombre) nombreEl.textContent = boton.dataset.mtNombre;
    if (precioEl && boton.dataset.mtPrecio) precioEl.textContent = boton.dataset.mtPrecio;
  }

  function siguiente() { mostrar((actual + 1) % slides.length); }

  function detenerAuto() {
    if (temporizador) { clearInterval(temporizador); temporizador = null; }
  }
  function iniciarAuto() {
    if (reducirMovimiento) return;
    detenerAuto();
    temporizador = setInterval(siguiente, duracion);
  }

  selectores.forEach(function (boton, i) {
    boton.addEventListener('click', function () {
      mostrar(i);
      iniciarAuto();
    });
  });

  raiz.addEventListener('mouseenter', detenerAuto);
  raiz.addEventListener('mouseleave', iniciarAuto);
  raiz.addEventListener('touchstart', detenerAuto, { passive: true });

  mostrar(0);
  iniciarAuto();
}

// Contador real de visitas del día (no inventado): cada visitante suma 1 a
// un contador compartido que se reinicia solo cada día (la clave incluye la
// fecha). Si el servicio no responde, se oculta el aviso en vez de mostrar
// un número falso.
function initContadorVisitas() {
  var contenedor = document.querySelector('[data-mt-contador-visitas]');
  if (!contenedor) return;
  var numeroEl = contenedor.querySelector('[data-mt-contador-visitas-numero]');
  var hoy = new Date().toISOString().slice(0, 10);
  var clave = 'takecoo-visitas-' + hoy;

  fetch('https://abacus.jasoncameron.dev/hit/takecoo-effck8w4/' + clave)
    .then(function (r) { return r.json(); })
    .then(function (datos) {
      if (!datos || typeof datos.value !== 'number') throw new Error('sin dato');
      if (numeroEl) numeroEl.textContent = datos.value;
      contenedor.hidden = false;
    })
    .catch(function () {});
}

function initTemaOscuro() {
  var boton = document.querySelector('[data-mt-tema-boton]');
  if (!boton) return;

  function actualizarEtiqueta() {
    var activo = document.documentElement.getAttribute('data-mt-tema') === 'oscuro';
    boton.setAttribute('aria-label', activo ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro');
  }
  actualizarEtiqueta();

  boton.addEventListener('click', function () {
    var actual = document.documentElement.getAttribute('data-mt-tema') === 'oscuro' ? 'oscuro' : 'claro';
    var nuevo = actual === 'oscuro' ? 'claro' : 'oscuro';
    document.documentElement.setAttribute('data-mt-tema', nuevo);
    actualizarEtiqueta();
    try {
      localStorage.setItem('mt-tema', nuevo);
    } catch (e) {}
  });
}

function initReveal() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada, indice) {
        if (entrada.isIntersecting) {
          var el = entrada.target;
          var retraso = el.dataset.mtDelay ? parseInt(el.dataset.mtDelay, 10) : 0;
          setTimeout(function () { el.classList.add('mt-visible'); }, retraso);
          observer.unobserve(el);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  elementos.forEach(function (el) { observer.observe(el); });
}

function initGaleria() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-mt-galeria-thumb]');
    if (!principal || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.mtFull;
        var alt = thumb.dataset.mtAlt || '';
        if (!src || src === principal.src) return;
        thumbs.forEach(function (t) { t.classList.remove('mt-activo'); });
        thumb.classList.add('mt-activo');
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = src;
          principal.alt = alt;
          principal.style.opacity = '1';
        }, 180);
      });
    });
  });
}

// Barra fija de "comprar" en la ficha de producto: aparece cuando el
// formulario de compra real sale de la pantalla al hacer scroll. El botón
// de la barra simplemente hace clic en el botón real, así que reutiliza
// toda la lógica de variantes/carrito ya existente sin duplicarla.
function initStickyCompra() {
  var barra = document.querySelector('[data-mt-sticky-compra]');
  var form = document.querySelector('[data-mt-producto-form]');
  if (!barra || !form) return;

  var precioReal = document.querySelector('[data-mt-precio-actual]');
  var precioBarra = barra.querySelector('[data-mt-sticky-precio]');
  var botonReal = document.querySelector('[data-mt-boton-comprar]');
  var botonBarra = barra.querySelector('[data-mt-sticky-boton]');

  if (precioReal && precioBarra && 'MutationObserver' in window) {
    new MutationObserver(function () {
      precioBarra.textContent = precioReal.textContent;
    }).observe(precioReal, { childList: true, characterData: true, subtree: true });
  }

  if (botonReal && botonBarra) {
    botonBarra.addEventListener('click', function () { botonReal.click(); });
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        botonBarra.disabled = botonReal.disabled;
        botonBarra.textContent = botonReal.textContent;
      }).observe(botonReal, { attributes: true, childList: true, characterData: true, subtree: true, attributeFilter: ['disabled'] });
    }
  }

  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (entrada) {
      barra.classList.toggle('mt-visible', !entrada.isIntersecting && entrada.boundingClientRect.top < 0);
    });
  }, { threshold: 0 });
  observer.observe(form);
}

function initVariantes() {
  document.querySelectorAll('[data-mt-producto-form]').forEach(function (form) {
    var variantesRaw = form.querySelector('[data-mt-variantes-json]');
    if (!variantesRaw) return;

    var variantes;
    try {
      variantes = JSON.parse(variantesRaw.textContent);
    } catch (e) {
      return;
    }

    var raiz = form.closest('.mt-producto-seccion') || form;
    var inputId = form.querySelector('input[name="id"]');
    var botonesOpcion = form.querySelectorAll('[data-mt-opcion-valor]');
    var precioActual = raiz.querySelector('[data-mt-precio-actual]');
    var precioAnterior = raiz.querySelector('[data-mt-precio-anterior]');
    var botonComprar = form.querySelector('[data-mt-boton-comprar]');
    var avisoStock = form.querySelector('[data-mt-stock-aviso]');
    var insigniaNuevo = raiz.querySelector('[data-mt-nuevo]');
    var edicionesNuevas = ['Pink', 'Black'];
    var numOpciones = form.dataset.mtNumOpciones ? parseInt(form.dataset.mtNumOpciones, 10) : 1;

    function seleccionActual() {
      var valores = [];
      for (var i = 1; i <= numOpciones; i++) {
        var activo = form.querySelector('[data-mt-opcion="' + i + '"].mt-activo');
        valores.push(activo ? activo.dataset.mtOpcionValor : null);
      }
      return valores;
    }

    function encontrarVariante() {
      // Producto sin opciones (una sola variante): no hay botones que mirar.
      if (!botonesOpcion.length && variantes.length === 1) return variantes[0];
      var seleccion = seleccionActual();
      return variantes.find(function (v) {
        return v.options.every(function (op, idx) { return op === seleccion[idx]; });
      });
    }

    function formatearPrecio(centavos) {
      return mtFormatearDinero(centavos);
    }

    function actualizarEyebrow(variante) {
      var eyebrowEl = form.closest('.mt-producto-seccion');
      eyebrowEl = eyebrowEl ? eyebrowEl.querySelector('[data-mt-eyebrow]') : null;
      if (!eyebrowEl || !variante.option2) return;
      var talla = variante.option2.split(' ')[0].replace(/oz/gi, '') + 'oz';
      var plantilla = eyebrowEl.dataset.mtEyebrowPlantilla || eyebrowEl.textContent;
      eyebrowEl.textContent = plantilla.replace('[talla]', talla);
    }

    function actualizar(esInicial) {
      var variante = encontrarVariante();
      if (!variante) return;

      actualizarEyebrow(variante);

      if (insigniaNuevo) {
        insigniaNuevo.hidden = edicionesNuevas.indexOf(variante.option1) === -1;
      }

      inputId.value = variante.id;
      var estadoOferta = mtOfertaEstado();
      if (estadoOferta.elegible && window.__mtOfertaCantidadOk !== false && !mtOfertaProductoExcluido()) {
        var precioConDescuento = variante.price - Math.floor(variante.price * 0.3);
        if (precioActual) precioActual.textContent = formatearPrecio(precioConDescuento);
        if (precioAnterior) {
          precioAnterior.textContent = formatearPrecio(variante.price);
          precioAnterior.style.display = '';
        }
      } else {
        if (precioActual) precioActual.textContent = formatearPrecio(variante.price);
        if (precioAnterior) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioAnterior.textContent = formatearPrecio(variante.compare_at_price);
            precioAnterior.style.display = '';
          } else {
            precioAnterior.style.display = 'none';
          }
        }
      }

      var disponible = variante.available;
      if (botonComprar) {
        botonComprar.disabled = !disponible;
        botonComprar.textContent = disponible
          ? botonComprar.dataset.mtTextoDisponible
          : botonComprar.dataset.mtTextoAgotado;
      }
      if (avisoStock) {
        avisoStock.classList.toggle('mt-agotado', !disponible);
        avisoStock.textContent = disponible
          ? avisoStock.dataset.mtTextoDisponible || ''
          : avisoStock.dataset.mtTextoAgotado || '';
      }

      if (variante.featured_image && !esInicial) {
        var contenedorGaleria = form.closest('.mt-producto-seccion') || document;
        var principal = contenedorGaleria.querySelector('[data-mt-galeria-principal]');
        if (principal) {
          var nuevoSrc = variante.featured_image.src;
          if (nuevoSrc.indexOf('//') === 0) nuevoSrc = 'https:' + nuevoSrc;
          principal.src = nuevoSrc;
          principal.alt = variante.featured_image.alt || '';
        }
      }

      botonesOpcion.forEach(function (boton) {
        var opcionIdx = boton.dataset.mtOpcion;
        var valor = boton.dataset.mtOpcionValor;
        var pruebaSeleccion = seleccionActual();
        pruebaSeleccion[opcionIdx - 1] = valor;
        var existe = variantes.some(function (v) {
          return v.options.every(function (op, idx) {
            return pruebaSeleccion[idx] === null || op === pruebaSeleccion[idx];
          });
        });
        boton.classList.toggle('mt-agotado', !existe);
      });
    }

    function resolverCombinacionValida(botonClicado) {
      if (encontrarVariante()) return;
      var opcionIdx = parseInt(botonClicado.dataset.mtOpcion, 10);
      var valorClicado = botonClicado.dataset.mtOpcionValor;
      var candidata = variantes.find(function (v) { return v.options[opcionIdx - 1] === valorClicado; });
      if (!candidata) return;
      candidata.options.forEach(function (valor, idx) {
        var grupo = form.querySelectorAll('[data-mt-opcion="' + (idx + 1) + '"]');
        grupo.forEach(function (b) {
          b.classList.toggle('mt-activo', b.dataset.mtOpcionValor === valor);
        });
      });
    }

    botonesOpcion.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var grupo = form.querySelectorAll('[data-mt-opcion="' + boton.dataset.mtOpcion + '"]');
        grupo.forEach(function (b) { b.classList.remove('mt-activo'); });
        boton.classList.add('mt-activo');
        resolverCombinacionValida(boton);
        actualizar();
      });
    });

    actualizar(true);
    mtOfertaRegistrar(actualizar);
  });
}

function initParallax() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var envolturas = document.querySelectorAll('[data-mt-parallax-wrap]');
  if (!envolturas.length) return;

  var items = [];
  envolturas.forEach(function (wrap) {
    var imgs = wrap.querySelectorAll('[data-mt-parallax]');
    if (!imgs.length) return;
    var intensidad = parseFloat(wrap.dataset.mtParallaxIntensidad || '0');
    if (!intensidad) return;
    items.push({ wrap: wrap, imgs: imgs, intensidad: intensidad });
  });
  if (!items.length) return;

  var ticking = false;
  function actualizar() {
    var vh = window.innerHeight;
    items.forEach(function (item) {
      var rect = item.wrap.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var progreso = (rect.top) / vh;
      var desplazamiento = progreso * item.intensidad;
      for (var i = 0; i < item.imgs.length; i++) {
        item.imgs[i].style.transform = 'translateY(' + desplazamiento + 'px)';
      }
    });
    ticking = false;
  }
  function solicitar() {
    if (!ticking) {
      window.requestAnimationFrame(actualizar);
      ticking = true;
    }
  }
  window.addEventListener('scroll', solicitar, { passive: true });
  actualizar();
}

function initTilt() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;
  var tarjetas = document.querySelectorAll('.mt-beneficio-card, .mt-edicion-card, .mt-angulo-card, .mt-personaliza-foto, .card-wrapper .card--standard, .card-wrapper .card--card, .mt-detalle-card');

  tarjetas.forEach(function (tarjeta) {
    var maxGrados = 6;
    tarjeta.addEventListener('mousemove', function (e) {
      var rect = tarjeta.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      tarjeta.style.transform = 'perspective(600px) rotateX(' + (-y * maxGrados) + 'deg) rotateY(' + (x * maxGrados) + 'deg) translateY(-4px)';
    });
    tarjeta.addEventListener('mouseleave', function () {
      tarjeta.style.transform = '';
    });
  });
}

function initCountUp() {
  var elementos = document.querySelectorAll('[data-mt-countup]');
  if (!elementos.length) return;

  var observer = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        var el = entrada.target;
        var destino = parseFloat(el.dataset.mtCountup);
        var duracion = 1400;
        var inicio = null;

        function paso(marca) {
          if (!inicio) inicio = marca;
          var progreso = Math.min((marca - inicio) / duracion, 1);
          var valor = destino * (1 - Math.pow(1 - progreso, 3));
          el.textContent = (destino % 1 !== 0 ? valor.toFixed(1) : Math.round(valor)).toString();
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
        observer.unobserve(el);
      });
    },
    { threshold: 0.5 }
  );

  elementos.forEach(function (el) { observer.observe(el); });
}

var MT_OFERTA_CODIGO = 'BIENVENIDA30';
// La oferta de bienvenida solo vale si en el carrito hay 1 unidad como
// mucho: comprando más de una, deja de aplicarse. Empieza en "true" (más
// optimista) y se corrige en cuanto se puede leer el carrito de verdad.
window.__mtOfertaCantidadOk = true;
window.__mtOfertaListeners = [];
// Cualquier trozo de la página que enseñe un precio de oferta (ficha de
// producto, aviso emergente...) se apunta aquí para refrescarse solo en
// cuanto cambie el estado real de la oferta (cuenta atrás, carrito...).
function mtOfertaRegistrar(callback) {
  window.__mtOfertaListeners.push(callback);
}
// Productos que no cuentan para la oferta (p. ej. el airbag, que va aparte):
// no suman para el límite de 1 unidad y su ficha no enseña el precio rebajado.
function mtOfertaExcluidos() {
  var barra = document.querySelector('[data-mt-oferta-bienvenida]');
  return barra && barra.dataset.mtOfertaExcluidos ? barra.dataset.mtOfertaExcluidos.split(',') : [];
}
function mtOfertaProductoExcluido() {
  var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
  return !!m && mtOfertaExcluidos().indexOf(decodeURIComponent(m[1])) !== -1;
}
function mtOfertaNotificar() {
  window.__mtOfertaListeners.forEach(function (cb) {
    try { cb(); } catch (e) {}
  });
}

// Detecta cuando el carrito cambia de verdad (añadir o cambiar cantidad) y
// vuelve a comprobar si la oferta sigue tocando. No engancha /cart/update.js
// porque esa es la propia llamada que usamos aquí para quitar el descuento
// (si no, se llamaría a sí misma sin parar).
(function () {
  var fetchOriginal = window.fetch;
  window.fetch = function (recurso, opciones) {
    var promesa = fetchOriginal.apply(this, arguments);
    try {
      var url = typeof recurso === 'string' ? recurso : (recurso && recurso.url) || '';
      if (/\/cart\/(add|change)(\.js)?(\?|$)/.test(url)) {
        promesa
          .then(function () {
            window.setTimeout(function () {
              mtOfertaSincronizarDescuento(mtOfertaEstado());
            }, 250);
          })
          .catch(function () {});
      }
    } catch (e) {}
    return promesa;
  };
})();

// Cada navegador tiene una hora de oferta (30% dto.) que empieza en su
// primera visita del día y se reinicia solo cada día siguiente. Pasada esa
// hora, deja de ser elegible hasta el día siguiente.
function mtOfertaEstado() {
  var barra = document.querySelector('[data-mt-oferta-bienvenida]');
  var minutos = barra ? parseFloat(barra.dataset.mtOfertaMinutos || '60') : 60;
  var hoy = new Date().toISOString().slice(0, 10);
  var fin;
  try {
    var diaGuardado = localStorage.getItem('mt-oferta-dia');
    if (diaGuardado !== hoy) {
      fin = Date.now() + minutos * 60000;
      localStorage.setItem('mt-oferta-dia', hoy);
      localStorage.setItem('mt-oferta-fin', String(fin));
    } else {
      fin = parseInt(localStorage.getItem('mt-oferta-fin'), 10) || 0;
    }
  } catch (e) {
    fin = Date.now() + minutos * 60000;
  }
  return { hoy: hoy, fin: fin, elegible: Date.now() < fin };
}

// Aplica o quita de verdad el código de descuento del carrito según toque,
// para que lo que se paga en caja coincida siempre con lo que se muestra.
// La oferta solo vale con 1 unidad en el carrito como mucho (sin contar los
// productos excluidos, como el airbag). Si en el carrito solo hay excluidos,
// se quita el código porque no tendría a qué aplicarse.
function mtOfertaSincronizarDescuento(estado) {
  function aplicarSegun(cantidadOk, hayQueAplicar) {
    window.__mtOfertaCantidadOk = cantidadOk;
    if (estado.elegible && cantidadOk && hayQueAplicar) {
      fetch('/discount/' + MT_OFERTA_CODIGO, { credentials: 'include' }).catch(function () {});
    } else {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      }).catch(function () {});
    }
    mtOfertaNotificar();
  }

  fetch('/cart.js', { credentials: 'include' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var excluidos = mtOfertaExcluidos();
      var unidades = 0;
      (cart.items || []).forEach(function (item) {
        if (excluidos.indexOf(item.handle) === -1) unidades += item.quantity;
      });
      var soloExcluidos = (cart.item_count || 0) > 0 && unidades === 0;
      aplicarSegun(unidades <= 1, !soloExcluidos);
    })
    .catch(function () { aplicarSegun(true, true); });
}

function initOfertaBienvenida() {
  var estado = mtOfertaEstado();
  mtOfertaSincronizarDescuento(estado);

  var barra = document.querySelector('[data-mt-oferta-bienvenida]');
  if (!barra) return;

  var hoyCerrada;
  try {
    hoyCerrada = localStorage.getItem('mt-oferta-cerrada-dia') === estado.hoy;
  } catch (e) {
    hoyCerrada = false;
  }
  if (!estado.elegible || hoyCerrada) return;

  var elMin = barra.querySelector('[data-mt-oferta-min]');
  var elSeg = barra.querySelector('[data-mt-oferta-seg]');
  var botonCerrar = barra.querySelector('[data-mt-oferta-cerrar]');
  var intervalo;

  function ocultar() {
    if (intervalo) clearInterval(intervalo);
    barra.hidden = true;
  }

  function actualizar() {
    var restante = estado.fin - Date.now();
    if (restante <= 0) {
      ocultar();
      mtOfertaSincronizarDescuento({ elegible: false });
      return;
    }
    var totalSeg = Math.floor(restante / 1000);
    var min = Math.floor(totalSeg / 60);
    var seg = totalSeg % 60;
    if (elMin) elMin.textContent = (min < 10 ? '0' : '') + min;
    if (elSeg) elSeg.textContent = (seg < 10 ? '0' : '') + seg;
  }

  if (botonCerrar) {
    botonCerrar.addEventListener('click', function () {
      try { localStorage.setItem('mt-oferta-cerrada-dia', estado.hoy); } catch (e) {}
      ocultar();
    });
  }

  barra.hidden = false;
  actualizar();
  intervalo = setInterval(actualizar, 1000);
}

// Aviso emergente de producto nuevo (edición Pink). Sale en cada visita a
// no ser que el usuario pulse "No volver a mostrar" (entonces se recuerda
// para siempre en ese navegador). El precio que enseña es siempre el real
// según la oferta de bienvenida esté activa o no.
function initPopupNuevo() {
  var popup = document.querySelector('[data-mt-popup-nuevo]');
  if (!popup) return;

  try {
    if (localStorage.getItem('mt-popup-nuevo-oculto') === '1') return;
  } catch (e) {}

  var precioBase = parseInt(popup.dataset.mtPrecioBase, 10) || 6599;
  var precioActualEl = popup.querySelector('[data-mt-popup-precio-actual]');
  var precioAnteriorEl = popup.querySelector('[data-mt-popup-precio-anterior]');

  function formatearPrecio(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR'
    });
  }

  function actualizarPrecio() {
    var estadoOferta = mtOfertaEstado();
    if (estadoOferta.elegible && window.__mtOfertaCantidadOk !== false) {
      var precioConDescuento = precioBase - Math.floor(precioBase * 0.3);
      if (precioActualEl) precioActualEl.textContent = formatearPrecio(precioConDescuento);
      if (precioAnteriorEl) precioAnteriorEl.textContent = formatearPrecio(precioBase);
    } else {
      if (precioActualEl) precioActualEl.textContent = formatearPrecio(precioBase);
      if (precioAnteriorEl) precioAnteriorEl.textContent = '';
    }
  }
  actualizarPrecio();
  mtOfertaRegistrar(actualizarPrecio);

  function cerrar() {
    popup.hidden = true;
  }

  popup.querySelectorAll('[data-mt-popup-cerrar]').forEach(function (el) {
    el.addEventListener('click', cerrar);
  });

  var botonNoMostrar = popup.querySelector('[data-mt-popup-no-mostrar]');
  if (botonNoMostrar) {
    botonNoMostrar.addEventListener('click', function () {
      try { localStorage.setItem('mt-popup-nuevo-oculto', '1'); } catch (e) {}
      cerrar();
    });
  }

  window.setTimeout(function () {
    popup.hidden = false;
  }, 900);
}

// En móvil, un vídeo "autoplay" que empieza fuera de pantalla (más abajo del
// todo) muchas veces no arranca solo por ahorro de batería/datos del propio
// teléfono. Forzamos el play() en cuanto entra en pantalla, y reintentamos
// si el navegador lo pausa por su cuenta mientras sigue siendo visible.
function initVideosAutoplay() {
  var videos = document.querySelectorAll('video[autoplay]');
  if (!videos.length || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        var video = entrada.target;
        if (entrada.isIntersecting) {
          var intento = video.play();
          if (intento && intento.catch) intento.catch(function () {});
        }
      });
    },
    { threshold: 0.25 }
  );

  videos.forEach(function (video) {
    observer.observe(video);
    video.addEventListener('pause', function () {
      var rect = video.getBoundingClientRect();
      var visible = rect.top < window.innerHeight && rect.bottom > 0;
      if (visible && !video.ended) {
        var intento = video.play();
        if (intento && intento.catch) intento.catch(function () {});
      }
    });
  });
}

// Aviso corto (p. ej. "colección agotada"). Se cierra para el resto de la
// visita (pestaña actual); al volver otro día, vuelve a salir.
function initAlertaMini() {
  var alerta = document.querySelector('[data-mt-alerta-mini]');
  if (!alerta) return;

  try {
    if (sessionStorage.getItem('mt-alerta-mini-cerrada') === '1') return;
  } catch (e) {}

  alerta.hidden = false;

  var botonCerrar = alerta.querySelector('[data-mt-alerta-cerrar]');
  if (botonCerrar) {
    botonCerrar.addEventListener('click', function () {
      alerta.hidden = true;
      try { sessionStorage.setItem('mt-alerta-mini-cerrada', '1'); } catch (e) {}
    });
  }
}

// Página del carrito: cambiar cantidades y quitar productos sin recargar.
// Tras cada cambio se vuelven a pedir a Shopify solo las piezas que cambian
// (productos, cifras y contador), sin tocar los botones de pago rápido.
// Sin JavaScript, los mismos enlaces funcionan recargando la página.
function initCarrito() {
  if (!document.querySelector('[data-mt-carrito]')) return;
  var ocupado = false;

  function repintar() {
    var raiz = document.querySelector('[data-mt-carrito]');
    if (!raiz) return Promise.resolve();
    var id = raiz.dataset.mtSeccion;
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id) + ',cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (secciones) {
        var nuevo = new DOMParser().parseFromString(secciones[id] || '', 'text/html');
        var vacio = !nuevo.querySelector('[data-mt-carrito-parte="lineas"]');
        if (vacio && document.querySelector('[data-mt-carrito-parte="lineas"]')) {
          window.location.reload();
          return;
        }
        document.querySelectorAll('[data-mt-carrito] [data-mt-carrito-parte]').forEach(function (parte) {
          var reemplazo = nuevo.querySelector('[data-mt-carrito-parte="' + parte.dataset.mtCarritoParte + '"]');
          if (reemplazo) parte.innerHTML = reemplazo.innerHTML;
        });
        var burbuja = document.getElementById('cart-icon-bubble');
        if (burbuja && secciones['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(secciones['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) burbuja.innerHTML = b.innerHTML;
        }
      });
  }

  document.addEventListener('click', function (e) {
    var enlace = e.target.closest('[data-mt-carrito] [data-mt-linea]');
    if (!enlace) return;
    e.preventDefault();
    if (ocupado) return;
    ocupado = true;
    var raiz = document.querySelector('[data-mt-carrito]');
    raiz.classList.add('mt-cargando');
    var aviso = raiz.querySelector('[data-mt-carrito-error]');
    if (aviso) aviso.hidden = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(enlace.dataset.mtLinea, 10), quantity: parseInt(enlace.dataset.mtCantidad, 10) })
    })
      .then(function (r) { return r.json().then(function (datos) { return { ok: r.ok, datos: datos }; }); })
      .then(function (res) {
        if (!res.ok) {
          var error = document.querySelector('[data-mt-carrito-error]');
          if (error) {
            error.textContent = res.datos.description || res.datos.message || '';
            error.hidden = false;
          }
          return;
        }
        return repintar();
      })
      .catch(function () { window.location.href = enlace.href; })
      .then(function () {
        ocupado = false;
        var r = document.querySelector('[data-mt-carrito]');
        if (r) r.classList.remove('mt-cargando');
      });
  });

  // La nota del pedido ("¿Qué BMW tienes?") se guarda sola mientras se escribe.
  var temporizador;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-mt-carrito-nota]')) return;
    var valor = e.target.value;
    clearTimeout(temporizador);
    temporizador = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: valor })
      }).catch(function () {});
    }, 500);
  });

  // Si la oferta de bienvenida pone o quita su descuento, se refrescan las cifras.
  if (typeof mtOfertaRegistrar === 'function') {
    mtOfertaRegistrar(function () { setTimeout(repintar, 1200); });
  }
}

// Aviso del airbag en la ficha de producto. En los volantes ("ofrecer"): al
// pulsar Comprar se ofrecen los airbags (no vienen incluidos) y, según el BMW
// que elija el cliente, se marcan los compatibles y se bloquean los que no. En
// la ficha de un airbag ("comprobar"): solo deja añadirlo si el modelo encaja.
// Compatibles = códigos de chasis separados por comas; con * al final vale toda
// la serie (F* = serie F, F4* = F40 a F49, G* = serie G). De cada elemento solo
// cuenta la primera palabra, así que "F80 (M3)" vale como F80.
// El modelo elegido se recuerda y se guarda en la nota del pedido si estaba vacía.
function mtAirbagCompatible(codigos, modelo) {
  var palabras = String(modelo || '').toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean);
  return String(codigos || '').split(',').some(function (c) {
    c = c.trim().toUpperCase().split(/\s+/)[0];
    if (!c) return false;
    if (c.slice(-1) === '*') {
      var prefijo = c.slice(0, -1);
      return palabras.some(function (p) { return /^[A-Z]\d+$/.test(p) && p.indexOf(prefijo) === 0; });
    }
    return palabras.indexOf(c) !== -1;
  });
}

function initAvisoAirbag() {
  var modal = document.querySelector('[data-mt-airbag-aviso]');
  var form = document.querySelector('[data-mt-producto-form]');
  if (!modal || !form) return;
  var modo = modal.dataset.mtModo;
  var opciones = Array.prototype.slice.call(modal.querySelectorAll('[data-mt-airbag-opcion]'));
  if (modo === 'ofrecer' && (!opciones.length || modal.dataset.mtEnCarrito === 'true')) return;

  var panel = modal.querySelector('.mt-airbag-panel');
  var select = modal.querySelector('[data-mt-airbag-select]');
  var resultado = modal.querySelector('[data-mt-airbag-resultado]');
  var botonSi = modal.querySelector('[data-mt-airbag-si]');
  var botonNo = modal.querySelector('[data-mt-airbag-no]');
  var lista = modal.querySelector('[data-mt-airbag-lista]');
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var dejarPasar = false;
  var ultimoFoco = null;

  function radio(o) { return o.querySelector('input[type="radio"]'); }
  function elegida() {
    for (var i = 0; i < opciones.length; i++) if (radio(opciones[i]).checked) return opciones[i];
    return null;
  }
  function marcarElegida() {
    var e = elegida();
    opciones.forEach(function (o) { o.classList.toggle('mt-elegida', o === e); });
    if (lista) lista.textContent = e ? e.dataset.mtCompatTexto || '' : '';
  }

  function actualizar() {
    var modelo = select.value;
    modal.classList.remove('mt-airbag-ok', 'mt-airbag-mal', 'mt-airbag-falta');
    botonSi.disabled = false;
    resultado.textContent = '';

    if (modo !== 'ofrecer') {
      if (!modelo) return;
      if (mtAirbagCompatible(modal.dataset.mtCompatibles, modelo)) {
        modal.classList.add('mt-airbag-ok');
        resultado.textContent = (modal.dataset.mtTextoSi || '').replace('[modelo]', modelo);
      } else {
        modal.classList.add('mt-airbag-mal');
        resultado.textContent = (modal.dataset.mtTextoNo || '').replace('[modelo]', modelo);
        botonSi.disabled = true;
      }
      try { localStorage.setItem('mt-modelo-bmw', modelo); } catch (e) {}
      return;
    }

    // Ofrecer: cada airbag dice si encaja; los que no, se bloquean.
    var compatibles = 0;
    opciones.forEach(function (o) {
      var estado = o.querySelector('[data-mt-airbag-estado]');
      o.classList.remove('mt-compatible', 'mt-incompatible');
      if (!modelo) { radio(o).disabled = false; if (estado) estado.textContent = ''; return; }
      var ok = mtAirbagCompatible(o.dataset.mtCompatibles, modelo);
      o.classList.add(ok ? 'mt-compatible' : 'mt-incompatible');
      radio(o).disabled = !ok;
      if (estado) estado.textContent = ok ? modal.dataset.mtEstadoSi : modal.dataset.mtEstadoNo;
      if (ok) compatibles++;
    });
    if (modelo) {
      var e = elegida();
      if (!e || radio(e).disabled) {
        opciones.forEach(function (o) { radio(o).checked = false; });
        for (var i = 0; i < opciones.length; i++) if (!radio(opciones[i]).disabled) { radio(opciones[i]).checked = true; break; }
      }
      if (compatibles) {
        modal.classList.add('mt-airbag-ok');
        resultado.textContent = (modal.dataset.mtTextoSi || '').replace('[modelo]', modelo);
      } else {
        modal.classList.add('mt-airbag-mal');
        resultado.textContent = (modal.dataset.mtTextoNo || '').replace('[modelo]', modelo);
        botonSi.disabled = true;
      }
      try { localStorage.setItem('mt-modelo-bmw', modelo); } catch (err) {}
    }
    marcarElegida();
  }

  // Si la versión elegida del volante es un modelo de BMW (p. ej. el Deportivo M
  // se elige por M3 / M5 / E90), ese es su coche: se pone solo en el desplegable.
  // Primero se busca una línea que sea exactamente ese modelo; si no, una que lo contenga.
  function modeloDesdeVariante() {
    var datos = form.querySelector('[data-mt-variantes-json]');
    var campoId = form.querySelector('[name="id"]');
    if (!datos || !campoId) return '';
    var variante;
    try {
      variante = JSON.parse(datos.textContent).find(function (v) { return String(v.id) === campoId.value; });
    } catch (e) { return ''; }
    if (!variante) return '';
    var encontrado = '';
    (variante.options || []).forEach(function (valor) {
      var buscado = String(valor).toUpperCase().trim();
      if (encontrado) return;
      Array.prototype.forEach.call(select.options, function (opcion) {
        if (!encontrado && opcion.value && opcion.value.toUpperCase().trim() === buscado) encontrado = opcion.value;
      });
      Array.prototype.forEach.call(select.options, function (opcion) {
        if (encontrado || !opcion.value) return;
        if (opcion.value.toUpperCase().split(/[^A-Z0-9]+/).indexOf(buscado) !== -1) encontrado = opcion.value;
      });
    });
    return encontrado;
  }

  function abrir() {
    var delVolante = modo === 'ofrecer' ? modeloDesdeVariante() : '';
    if (delVolante) select.value = delVolante;
    actualizar();
    ultimoFoco = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('mt-airbag-abierto');
    requestAnimationFrame(function () { modal.classList.add('mt-visible'); });
    panel.focus();
  }

  function cerrar() {
    modal.classList.remove('mt-visible');
    document.documentElement.classList.remove('mt-airbag-abierto');
    setTimeout(function () { modal.hidden = true; }, 250);
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  function pedirModelo() {
    modal.classList.remove('mt-airbag-ok', 'mt-airbag-mal');
    modal.classList.add('mt-airbag-falta');
    resultado.textContent = modal.dataset.mtTextoElige || '';
    select.focus();
  }

  // Guarda "Mi BMW: F30 · Serie 3" en la nota del pedido si aún está vacía.
  function guardarModelo() {
    var modelo = select.value;
    if (!modelo) return Promise.resolve();
    return fetch(raiz + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        if (carrito.note) return;
        return fetch(raiz + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: ((modal.dataset.mtNota || '') + ' ' + modelo).trim() })
        });
      })
      .catch(function () {});
  }

  function enviarFormulario() {
    dejarPasar = true;
    HTMLFormElement.prototype.submit.call(form);
  }

  function cargando() {
    botonSi.disabled = true;
    if (botonNo) botonNo.disabled = true;
    botonSi.textContent = modal.dataset.mtTextoCargando || botonSi.textContent;
  }

  form.addEventListener('submit', function (e) {
    if (dejarPasar) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    abrir();
  }, true);

  select.addEventListener('change', actualizar);
  opciones.forEach(function (o) { radio(o).addEventListener('change', marcarElegida); });

  modal.querySelectorAll('[data-mt-airbag-cerrar]').forEach(function (el) {
    el.addEventListener('click', cerrar);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) cerrar();
  });

  botonSi.addEventListener('click', function () {
    if (!select.value) { pedirModelo(); return; }
    if (modo !== 'ofrecer') {
      if (!mtAirbagCompatible(modal.dataset.mtCompatibles, select.value)) return;
      cargando();
      guardarModelo().then(enviarFormulario);
      return;
    }
    var e = elegida();
    if (!e || radio(e).disabled) return;
    cargando();
    var idVolante = parseInt(form.querySelector('[name="id"]').value, 10);
    var campoCantidad = form.querySelector('[name="quantity"]');
    var cantidad = campoCantidad ? parseInt(campoCantidad.value, 10) || 1 : 1;
    // La nota se guarda antes de añadir: al añadir, la oferta de bienvenida
    // reaplica su código y, si coincidieran, una escritura podría pisar a la otra.
    guardarModelo()
      .then(function () {
        return fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id: idVolante, quantity: cantidad },
            { id: parseInt(e.dataset.mtVariante, 10), quantity: 1 }
          ] })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = raiz + 'cart'; })
      .catch(function () { enviarFormulario(); });
  });

  if (botonNo) {
    botonNo.addEventListener('click', function () {
      cargando();
      guardarModelo().then(enviarFormulario);
    });
  }

  // Si ya eligió su modelo en otra ficha, se deja puesto.
  try {
    var guardado = localStorage.getItem('mt-modelo-bmw');
    if (guardado && select.querySelector('option[value="' + guardado.replace(/"/g, '\\"') + '"]')) {
      select.value = guardado;
    }
  } catch (e) {}
  actualizar();

  // Si vuelve atrás desde el carrito, el navegador puede restaurar la página
  // tal cual: se deja todo listo para volver a comprar.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    dejarPasar = false;
    modal.classList.remove('mt-visible');
    modal.hidden = true;
    document.documentElement.classList.remove('mt-airbag-abierto');
    window.location.reload();
  });
}

// Escribe un precio con el mismo formato que usa la tienda (p. ej. "$284.11"),
// copiándolo de un ejemplo que pinta Shopify: 123456789 céntimos → "$1,234,567.89".
function mtFormatearDinero(centavos) {
  var el = document.querySelector('[data-mt-dinero-ejemplo]');
  var ejemplo = el ? el.dataset.mtDineroEjemplo || '' : '';
  var m = ejemplo.match(/^(.*?)1(\D?)234\D?567(?:(\D)89)?(.*)$/);
  if (!m) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR'
    });
  }
  var entero = String(Math.floor(centavos / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
  var decimales = m[3] ? m[3] + ('0' + (centavos % 100)).slice(-2) : '';
  return m[1] + entero + decimales + m[4];
}

// Portada · Vídeos: al darle al play se reproduce con sonido y con los controles
// del vídeo; los demás se pausan. Al terminar vuelve a la portada con el play.
function initVideos() {
  document.querySelectorAll('[data-mt-videos]').forEach(function (raiz) {
    var tarjetas = raiz.querySelectorAll('.mt-video-card');

    function pausarOtros(actual) {
      raiz.querySelectorAll('[data-mt-video]').forEach(function (v) {
        if (v !== actual && !v.paused) v.pause();
      });
    }

    tarjetas.forEach(function (tarjeta) {
      var video = tarjeta.querySelector('[data-mt-video]');
      var boton = tarjeta.querySelector('[data-mt-video-play]');
      if (!video || !boton) return;

      boton.addEventListener('click', function () {
        pausarOtros(video);
        video.controls = true;
        video.muted = false;
        tarjeta.classList.add('mt-reproduciendo');
        var promesa = video.play();
        if (promesa && promesa.catch) {
          promesa.catch(function () {
            // Si el navegador no deja sonido sin gesto previo, se intenta en silencio.
            video.muted = true;
            video.play().catch(function () {});
          });
        }
      });

      video.addEventListener('play', function () {
        pausarOtros(video);
        tarjeta.classList.add('mt-reproduciendo');
      });

      video.addEventListener('ended', function () {
        video.controls = false;
        tarjeta.classList.remove('mt-reproduciendo');
        video.currentTime = 0;
        video.load();
      });
    });
  });
}

// Cifras (p. ej. "4.9★", "+200", "100%"): el número sube desde 0 cuando se ven;
// lo que va antes y después del número se queda igual.
function initDatosAnimados() {
  var elementos = document.querySelectorAll('[data-mt-dato-valor]');
  if (!elementos.length || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var observador = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (entrada) {
      if (!entrada.isIntersecting) return;
      observador.unobserve(entrada.target);
      var el = entrada.target;
      var texto = el.textContent.trim();
      var m = texto.match(/\d+(?:[.,]\d+)?/);
      if (!m) return;
      var separador = m[0].indexOf(',') !== -1 ? ',' : '.';
      var decimales = (m[0].split(/[.,]/)[1] || '').length;
      var destino = parseFloat(m[0].replace(',', '.'));
      var antes = texto.slice(0, m.index);
      var despues = texto.slice(m.index + m[0].length);
      var inicio = null;
      function paso(marca) {
        if (!inicio) inicio = marca;
        var progreso = Math.min((marca - inicio) / 1400, 1);
        var valor = destino * (1 - Math.pow(1 - progreso, 3));
        el.textContent = antes + valor.toFixed(decimales).replace('.', separador) + despues;
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = texto;
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.6 });
  elementos.forEach(function (el) { observador.observe(el); });
}

// Oferta de bienvenida en los listados (catálogo y tarjetas de la portada): mientras
// el visitante la tiene, sale el precio normal tachado y al lado el precio con la
// oferta (mismo cálculo que la ficha: precio − 30 %) y una etiqueta "-30%". Cuando
// deja de tenerla, vuelve el precio normal. Los productos excluidos (airbags) no cambian.
var MT_OFERTA_PORCENTAJE = 30;

// "€289,19 EUR" → { antes: "", importe: "€289,19 EUR", centimos: 28919, ... }
function mtOfertaLeerImporte(texto) {
  var m = texto.match(/\d[\d.,]*\d|\d/);
  if (!m) return null;
  var inicio = m.index;
  while (inicio > 0 && !/\s/.test(texto.charAt(inicio - 1))) inicio--;
  var numero = m[0];
  var dec = numero.match(/[.,](\d{2})$/);
  var enteros = (dec ? numero.slice(0, -3) : numero).replace(/[.,]/g, '');
  return {
    prefijo: texto.slice(0, inicio).trim(),
    importe: texto.slice(inicio).trim(),
    centimos: parseInt(enteros, 10) * 100 + (dec ? parseInt(dec[1], 10) : 0),
    numero: numero,
    separador: dec ? numero.charAt(numero.length - 3) : ''
  };
}

function mtOfertaEscribirImporte(leido, centimos) {
  var sinDecimales = leido.separador ? leido.numero.slice(0, -3) : leido.numero;
  var miles = sinDecimales.match(/[.,]/);
  var entero = String(Math.floor(centimos / 100));
  if (miles) entero = entero.replace(/\B(?=(\d{3})+(?!\d))/g, miles[0]);
  var nuevo = leido.separador ? entero + leido.separador + ('0' + (centimos % 100)).slice(-2) : entero;
  return leido.importe.replace(leido.numero, nuevo);
}

function initOfertaListados() {
  function handleDe(caja) {
    var a = caja.querySelector('a[href*="/products/"]') || (caja.matches && caja.matches('a[href*="/products/"]') ? caja : null);
    var m = a ? a.getAttribute('href').match(/\/products\/([^/?#]+)/) : null;
    return m ? decodeURIComponent(m[1]) : '';
  }

  function objetivos() {
    var lista = [];
    document.querySelectorAll('.mt-garaje-card [data-mt-importe]').forEach(function (el) {
      lista.push({ el: el, handle: el.dataset.mtHandle || handleDe(el.closest('.mt-garaje-card')) });
    });
    document.querySelectorAll('#product-grid .card-wrapper, #product-grid .product-card-wrapper').forEach(function (caja) {
      var el = caja.querySelector('.price__regular .price-item--regular') || caja.querySelector('.price-item--regular');
      if (el) lista.push({ el: el, handle: handleDe(caja) });
    });
    return lista;
  }

  function aplicar() {
    var estado = typeof mtOfertaEstado === 'function' ? mtOfertaEstado() : { elegible: false };
    var activa = estado.elegible && window.__mtOfertaCantidadOk !== false;
    var excluidos = typeof mtOfertaExcluidos === 'function' ? mtOfertaExcluidos() : [];
    objetivos().forEach(function (o) {
      var el = o.el;
      if (el.dataset.mtOriginal === undefined) el.dataset.mtOriginal = el.innerHTML;
      var poner = activa && o.handle && excluidos.indexOf(o.handle) === -1;
      if (!poner) {
        if (el.classList.contains('mt-con-oferta')) { el.innerHTML = el.dataset.mtOriginal; el.classList.remove('mt-con-oferta'); }
        return;
      }
      if (el.classList.contains('mt-con-oferta')) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = el.dataset.mtOriginal;
      var leido = mtOfertaLeerImporte(tmp.textContent.replace(/\s+/g, ' ').trim());
      if (!leido || !leido.centimos) return;
      // Shopify calcula el descuento redondeando hacia abajo al céntimo
      var oferta = leido.centimos - Math.floor(leido.centimos * MT_OFERTA_PORCENTAJE / 100);
      var esc = function (t) { var d = document.createElement('span'); d.textContent = t; return d.innerHTML; };
      el.innerHTML = (leido.prefijo ? '<span class="mt-oferta-prefijo">' + esc(leido.prefijo) + '</span> ' : '')
        + '<s class="mt-oferta-antes">' + esc(leido.importe) + '</s> '
        + '<span class="mt-oferta-ahora">' + esc(mtOfertaEscribirImporte(leido, oferta)) + '</span> '
        + '<span class="mt-oferta-chip">-' + MT_OFERTA_PORCENTAJE + '%</span>';
      el.classList.add('mt-con-oferta');
    });
  }

  aplicar();
  if (typeof mtOfertaRegistrar === 'function') mtOfertaRegistrar(aplicar);
  // La cuenta atrás termina: se revisa cada minuto
  setInterval(aplicar, 60000);
  // El catálogo se vuelve a pintar al filtrar u ordenar
  var rejilla = document.getElementById('ProductGridContainer');
  if (rejilla && 'MutationObserver' in window) {
    var pendiente;
    new MutationObserver(function () {
      clearTimeout(pendiente);
      pendiente = setTimeout(aplicar, 150);
    }).observe(rejilla, { childList: true, subtree: true });
  }
}
